import { c as _c } from "react/compiler-runtime";
import { FontWeights } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";

/**
 * An orange tag to show that something is new.
 */
export function NewTag() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Box component="div" sx={{
      backgroundColor: PALETTE_VARS.secondary.main,
      border: "none",
      color: "common.white",
      height: "16px",
      width: "36px",
      borderRadius: "9px",
      textTransform: "uppercase",
      fontSize: "10px",
      fontWeight: FontWeights.Bold,
      textAlign: "center"
    }}>New</Box>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}